<template>
    <b-tabs pills card h-100 d-flex flex-column style="width: 100%" :class="{ disabled: loadingConnectionCheck }">
        <!-- Connection configuration -->
        <b-tab>
            <template #title>
                <span class="tabHeaderText">
                    {{ $t('Connection') }}
                </span>
            </template>
            <b-form>
                <b-row>
                    <b-col cols="3">
                        <b-form-group :label="$t('opcConnexionType') + ' *'" label-for="protocolMode">
                            <b-form-select id="protocolMode" v-model="protocolMode" :options="protocolOptions" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr color="grey" />
                <b-row>
                    <b-col cols="3">
                        <b-form-group :label="$t('equipment.modbus.apiAddress')" label-for="apiAddress">
                            <b-form-input id="apiAddress" type="number" min="1" max="100" @change="(value) => {
                                if (value == null || value == '') {
                                    this.apiAddress = 1;
                                } else if (value > 100) {
                                    this.apiAddress = 100;
                                } else if (value < 1) {
                                    this.apiAddress = 1;
                                }
                            }
                                " v-model="apiAddress" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group :label="$t('equipment.modbus.pollingPeriod')" label-for="pollingPeriod">
                            <b-form-input id="pollingPeriod" type="number" min="100" max="3600000" @change="(value) => {
                                if (value == null || value == '') {
                                    this.pollingPeriod = 500;
                                } else if (value > 3600000) {
                                    this.pollingPeriod = 3600000;
                                } else if (value < 100) {
                                    this.pollingPeriod = 100;
                                }
                            }
                                " v-model="pollingPeriod" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group :label="$t('equipment.modbus.retriesBeforeFail')" label-for="retryBeforeFail">
                            <b-form-input id="retryBeforeFail" type="number" min="0" max="10" @change="(value) => {
                                if (value == null || value == '') {
                                    this.retryBeforeFail = 2;
                                } else if (value > 10) {
                                    this.retryBeforeFail = 10;
                                } else if (value < 0) {
                                    this.retryBeforeFail = 0;
                                }
                            }
                                " v-model="retryBeforeFail" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group :label="$t('equipment.modbus.maxAddressGap')" label-for="maxAddressGap" :description="$t('equipment.modbus.maxAddressGapHelp')">
                            <b-form-input id="maxAddressGap" type="number" min="0" max="2000" @change="onMaxAddressGapChange" v-model="maxAddressGap" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="3">
                        <b-button @click="onCheckConnection" :class="{ disabled: !canCheckConnection }">
                            {{ $t('equipment.opcua.checkConnection') }}
                            <font-awesome-icon v-if="loadingConnectionCheck" icon="fas fa-spinner-third" class="fa-lg fa-spin-custom" />
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-tab>
        <!-- Modbus query configuration -->
        <b-tab>
            <template #title>
                <span class="tabHeaderText">{{ $t('equipment.modbus.queryConfiguration') }} </span>
            </template>
            <b-row>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.discreteInputs')" label-for="discreteInputs">
                        <b-form-input id="discreteInputs" type="number" min="1" max="2000" @change="(value) => {
                            if (value == null || value == '') {
                                this.discreteInputs = 2000;
                            } else if (value > 2000) {
                                this.discreteInputs = 2000;
                            } else if (value < 1) {
                                this.discreteInputs = 1;
                            }
                        }
                            " v-model="discreteInputs" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.inputRegisters')" label-for="inputRegisters">
                        <b-form-input id="inputRegisters" type="number" min="1" max="125" @change="(value) => {
                            if (value == null || value == '') {
                                this.inputRegisters = 125;
                            } else if (value > 125) {
                                this.inputRegisters = 125;
                            } else if (value < 1) {
                                this.inputRegisters = 1;
                            }
                        }
                            " v-model="inputRegisters" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.coils')" label-for="coils">
                        <b-form-input id="coils" type="number" min="1" max="2000" @change="(value) => {
                            if (value == null || value == '') {
                                this.coils = 2000;
                            } else if (value > 2000) {
                                this.coils = 2000;
                            } else if (value < 1) {
                                this.coils = 1;
                            }
                        }
                            " v-model="coils" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.holdingRegisters')" label-for="holdingRegisters">
                        <b-form-input id="holdingRegisters" type="number" min="1" max="125" @change="(value) => {
                            if (value == null || value == '') {
                                this.holdingRegisters = 125;
                            } else if (value > 125) {
                                this.holdingRegisters = 125;
                            } else if (value < 1) {
                                this.holdingRegisters = 1;
                            }
                        }
                            " v-model="holdingRegisters" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-tab>
        <!-- TCP configuration -->
        <b-tab v-if="connexionType == 0">
            <template #title>
                <span class="tabHeaderText">
                    {{ $t('equipment.modbus.tcpConfiguration') }}
                    <font-awesome-icon icon="fa fa-warning" class="ml-1 text-danger" v-if="invalidTCPIPState" />
                </span>
            </template>
            <b-row>
                <b-col cols="3">
                    <b-form-group :label="`${$t('IP')} *`" label-for="ipAddress">
                        <b-form-input id="ipAddress" :state="ipAddressState" v-model="ipAddress" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('Timeout') + ' (ms) *'" label-for="timeout">
                        <b-form-input id="timeout" type="number" min="0" max="120000" @change="(value) => {
                            if (value == null || value == '') {
                                this.timeout = 2000;
                            } else if (value > 120000) {
                                this.timeout = 120000;
                            } else if (value < 0) {
                                this.timeout = 0;
                            }
                        }
                            " v-model="timeout" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.port')" label-for="port">
                        <b-form-input id="port" type="number" min="1" max="65535" @change="(value) => {
                            if (value == null || value == '') {
                                this.port = 502;
                            } else if (value > 65535) {
                                this.port = 65535;
                            } else if (value < 1) {
                                this.port = 1;
                            }
                        }
                            " v-model="port" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col v-if="frameShiftApplicable" cols="3">
                    <b-form-group :label="$t('equipment.modbus.frameShift')" label-for="frameShift">
                        <b-form-input id="frameShift" type="number" min="0" max="1024" @change="(value) => {
                            if (value == null || value == '') {
                                this.frameShift = 2;
                            } else if (value > 1024) {
                                this.frameShift = 1024;
                            } else if (value < 0) {
                                this.frameShift = 0;
                            }
                        }
                            " v-model="frameShift" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-tab>
        <!-- Serial configuration -->
        <b-tab v-if="connexionType == 1">
            <template #title>
                <span class="tabHeaderText">{{ $t('equipment.modbus.comPort') }}</span>
            </template>
            <b-row>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.comPortUsed')" label-for="comPort">
                        <b-form-select
                            id="comPort"
                            v-model="comPort"
                            :options="availablePorts"
                            :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        variant="primary"
                        style="margin-top: 31px"
                        @click="testPort"
                        :disabled="testingPort || !comPort || !this.$store.state.auth.user.permissions.PermissionWrite"
                    >
                        {{ $t('equipment.modbus.testPort') }}
                        <font-awesome-icon v-if="testingPort" icon="fas fa-spinner-third" class="fa-lg fa-spin-custom" />
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.speed') + ' (bit/s)'" label-for="comSpeed">
                        <b-form-select id="comSpeed" v-model="comSpeed" :options="availableSpeeds" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('Timeout') + ' (ms)'" label-for="timeout">
                        <b-form-input id="timeout" type="number" min="1" max="120000" @change="(value) => {
                            if (value == null || value == '') {
                                this.timeout = 2000;
                            } else if (value > 120000) {
                                this.timeout = 120000;
                            } else if (value < 1) {
                                this.timeout = 1;
                            }
                        }
                            " v-model="timeout" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.dataBits')" label-for="comDataBits">
                        <b-form-select id="comDataBits" v-model="comDataBits" :options="availableDataBits" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.parity')" label-for="comParity">
                        <b-form-select id="comParity" v-model="comParity" :options="availableParities" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group :label="$t('equipment.modbus.stopBits')" label-for="comStopBit">
                        <b-form-select id="comStopBit" v-model="comStopBit" :options="availableStopBits" :class="{ disabled: !this.$store.state.auth.user.permissions.PermissionWrite }" />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-tab>
        <!-- Reconnection configuration -->
        <b-tab>
            <template #title>
                <span class="tabHeaderText">{{ $t('equipment.reconnect.tab') }}</span>
                <font-awesome-icon icon="fa fa-warning" class="ml-1 text-danger" v-if="reconnectInvalid" />
            </template>
            <Configuration_Reconnect
                ref="reconnectConfiguration"
                :value="equipment && equipment.Reconnect"
                @invalid-change="reconnectInvalid = $event"
            />
        </b-tab>
        <!-- Item configuration -->
        <b-tab>
            <template #title>
                {{ $t('Variables') }}
                <b-badge pill variant="info">{{
                    groups
                        .map((gr) => gr.Items.length)
                        .reduce(function (a, b) {
                            return a + b;
                        }, 0)
                }}</b-badge>
            </template>
            <ItemConfiguration ref="itemConfiguration" :columns="itemColumns" :groups="groups" :readonly="!this.$store.state.auth.user.permissions.PermissionWrite" :separateGroupConfig="false" :groupConfiguration="groupConfiguration" :updateMode="updateMode" :RefreshVarCounter="refreshVariablesCounter" :onEditingStartProp="onEditingStart" :onContentReadyProp="onContentReady" :calculateCellDisplayValueProp="calculateCellDisplayValue" />
        </b-tab>
    </b-tabs>
</template>

<script>
import ItemConfiguration from '@/components/configuration/Equipments/ItemConfiguration.vue';
import Configuration_Reconnect from '@/components/configuration/Equipments/Configuration_Reconnect.vue';
import prodComEquipmentService from '@/services/prodcom.equipments.service';
import ToastAlert from '@/utils/ToastAlert';
import { uuid } from 'vue-uuid';

function resolveProtocolMode(equipment) {
    const connectionType = Number(equipment?.ConnectionType ?? 0);
    const serialOverTcp = equipment?.SerialOverTCP === true;
    const transmissionMode = Number(equipment?.TransmissionMode ?? 0);

    if (connectionType === 1) {
        return transmissionMode === 1 ? 'rtu' : 'ascii';
    }
    if (serialOverTcp) {
        return transmissionMode === 1 ? 'rtuTcp' : 'asciiTcp';
    }
    return 'tcp';
}

function defaultMaxAddressGap(protocolMode) {
    if (protocolMode === 'rtu') return 10;
    if (protocolMode === 'ascii') return 5;
    return 20;
}

export default {
    name: 'ConfigModbus',
    components: {
        ItemConfiguration,
        Configuration_Reconnect,
    },
    props: {
        equipment: Object,
        onValidate: Function,
        updateMode: Boolean,
    },
    computed: {
        invalidState() {
            return this.ipAddressState === false || this.reconnectInvalid;
        },
        invalidTCPIPState() {
            return this.ipAddressState === false;
        },
        ipAddressState() {
            return this.connexionType == 0 && this.ipAddress == '' ? false : null;
        },
        connexionType() {
            return this.protocolMode === 'rtu' || this.protocolMode === 'ascii' ? 1 : 0;
        },
        serialViaTCP() {
            return this.protocolMode === 'rtuTcp' || this.protocolMode === 'asciiTcp';
        },
        transmission() {
            return this.protocolMode === 'rtu' || this.protocolMode === 'rtuTcp' ? 1 : 0;
        },
        frameShiftApplicable() {
            return this.protocolMode === 'tcp';
        },
        canCheckConnection() {
            if (this.loadingConnectionCheck || !this.$store.state.auth.user.permissions.PermissionRead) {
                return false;
            }
            if (this.connexionType == 0) {
                return this.ipAddress != null && this.ipAddress !== '';
            }
            return !!this.comPort;
        },
        canWrite() {
            return this.$store.state.auth.user.permissions.PermissionWrite;
        },
    },
    data() {
        const self = this;
        return {
            protocolOptions: [
                { value: 'tcp', text: this.$t('equipment.modbus.protocol.tcp') },
                { value: 'rtu', text: this.$t('equipment.modbus.protocol.rtu') },
                { value: 'ascii', text: this.$t('equipment.modbus.protocol.ascii') },
                { value: 'rtuTcp', text: this.$t('equipment.modbus.protocol.rtuOverTcp') },
                { value: 'asciiTcp', text: this.$t('equipment.modbus.protocol.asciiOverTcp') },
            ],
            protocolMode: resolveProtocolMode(this.equipment),
            apiAddress: this.equipment?.ApiAddress ?? 1,
            pollingPeriod: this.equipment?.TxRefresh ?? 500,
            retryBeforeFail: this.equipment?.Retries ?? 2,
            maxAddressGap: this.equipment?.MaxAddressGap ?? defaultMaxAddressGap(resolveProtocolMode(this.equipment)),
            frameShift: this.equipment?.FrameShift ?? 4,
            discreteInputs: this.equipment?.DiscreteInput ?? 2000,
            inputRegisters: this.equipment?.InputRegisters ?? 125,
            coils: this.equipment?.Coils ?? 2000,
            holdingRegisters: this.equipment?.HoldingRegisters ?? 125,
            ipAddress: this.equipment?.Host ?? '127.0.0.1',
            timeout: this.equipment?.Timeout ?? 2000,
            port: this.equipment?.TcpPort ?? 502,
            availablePorts: [],
            testingPort: false,
            loadingConnectionCheck: false,
            comPort: this.equipment?.ComPort ?? '',
            availableSpeeds: [75, 110, 134, 150, 300, 600, 1200, 1800, 2400, 4800, 7200, 9600, 14400, 19200, 38400, 57600, 115200, 128000],
            comSpeed: this.equipment?.BaudRate ?? 9600,
            availableDataBits: [4, 5, 6, 7, 8],
            comDataBits: this.equipment?.ByteSize ?? 8,
            availableParities: [
                { value: 0, text: this.$t('equipment.modbus.parity.none') },
                { value: 2, text: this.$t('equipment.modbus.parity.even') },
                { value: 1, text: this.$t('equipment.modbus.parity.odd') },
                { value: 3, text: this.$t('equipment.modbus.parity.mark') },
                { value: 4, text: this.$t('equipment.modbus.parity.space') },
            ],
            comParity: this.equipment?.Parity ?? 0,
            availableStopBits: [
                { text: '1', value: 1 },
                { text: '1.5', value: 3 },
                { text: '2', value: 2 },
            ],
            comStopBit: this.equipment?.StopBits ?? 1,
            reconnectInvalid: false,
            varGridView: null,
            onContentReady: function (e) {
                self.varGridView = e.component;
            },
            calculateCellDisplayValue: function (rowData, dataField) {
                let value = rowData[dataField];
                // if (dataField == 'ValueLength' && (rowData.Type != 'String' && rowData.Type != 'Real')) {
                //     value = null;
                // }
                if (dataField == 'Bit' && (rowData.Type != 'Bool' && rowData.Type != 'Bit')) {
                    value = null;
                }
                return value;
            },
            onEditingStart: function (e) {
                // Manage Type column options
                if (e.data.ZoneName == 'Discretes_Input' || e.data.ZoneName == 'Coils') {
                    e.component.columnOption('Type', 'lookup.dataSource', ['Bool', 'Bit']);
                    if (['Bool', 'Bit'].indexOf(e.data.Type) == -1) {
                        e.data.Type = null;
                    }
                } else {
                    e.component.columnOption('Type', 'lookup.dataSource', ['Bool', 'Bit', 'String', 'Char', 'Real', 'DReal', 'Word', 'DWord', 'Int', 'DInt']);
                }
                // Manage ValueLength column options
                if (e.data.Type == 'String') {
                    e.component.columnOption('ValueLength', 'allowEditing', true);
                    e.data.ValueLength = null;
                } else {
                    e.component.columnOption('ValueLength', 'allowEditing', false);
                    switch (e.data.Type) {
                        case 'Bool':
                        case 'Bit':
                        case 'Word':
                        case 'Int':
                        case 'Char':
                            e.data.ValueLength = 1;
                            break;
                        case 'DWord':
                        case 'DInt':
                        case 'Real':
                            e.data.ValueLength = 2;
                            break;
                        case 'DReal':
                            e.data.ValueLength = 4;
                            break;
                        default:
                            e.data.ValueLength = null;
                            break;
                    }
                }
                // Manage Bit column options
                if (e.data.Type == 'Bool' || e.data.Type == 'Bit') {
                    e.component.columnOption('Bit', 'allowEditing', true);
                    if (e.data.ValueIndex == null || e.data.ValueIndex == '') {
                        e.data.ValueIndex = 0;
                    }
                } else {
                    e.component.columnOption('Bit', 'allowEditing', false);
                    e.data.ValueIndex = 0;
                }
                // Manage BooleanDirection column options
                if (e.data.Type == 'String' || e.data.Type == 'Real' || e.data.Type == 'DReal' || e.data.Type == 'DWord' || e.data.Type == 'DInt') {
                    e.component.columnOption('BooleanDirection', 'allowEditing', true);
                } else {
                    e.component.columnOption('BooleanDirection', 'allowEditing', false);
                    e.data.BooleanDirection = false;
                }
            },
            itemColumns: [
                { key: 'Name', dataField: 'Name', dataType: 'string', caption: this.$t('Name'), required: true, width: 150 },
                {
                    key: 'Zone',
                    dataField: 'ZoneName',
                    dataType: 'string',
                    caption: this.$t('Zone'),
                    required: true,
                    options: ['Discretes_Input', 'Coils', 'Input_Registers', 'Holding_Registers'],
                    width: 150,
                    setCellValue: function (newData, value, currentRowData) {
                        newData.ZoneName = value;
                        switch (value) {
                            case 'Discretes_Input':
                            case 'Coils':
                                self.varGridView.columnOption('Type', 'lookup.dataSource', ['Bool', 'Bit']);
                                if (['Bool', 'Bit'].indexOf(newData.Type) == -1) {
                                    newData.Type = null;
                                }
                                break;
                            default:
                                self.varGridView.columnOption('Type', 'lookup.dataSource', ['Bool', 'Bit', 'String', 'Char', 'Real', 'DReal', 'Word', 'DWord', 'Int', 'DInt']);
                                break;
                        }
                    },
                },
                {
                    key: 'Type',
                    dataField: 'Type',
                    dataType: 'string',
                    caption: this.$t('Type'),
                    required: true,
                    options: ['Bool', 'Bit', 'String', 'Char', 'Real', 'DReal', 'Word', 'DWord', 'Int', 'DInt'],
                    width: 120,
                    setCellValue: function (newData, value, currentRowData) {
                        console.log('Type', value);
                        newData.Type = value;
                        // Manage ValueLength column options
                        if (value == 'String') {
                            self.varGridView.columnOption('ValueLength', 'allowEditing', true);
                            newData.ValueLength = null;
                        } else {
                            self.varGridView.columnOption('ValueLength', 'allowEditing', false);
                            switch (value) {
                                case 'Bool':
                                case 'Bit':
                                case 'Word':
                                case 'Int':
                                case 'Char':
                                    newData.ValueLength = 1;
                                    break;
                                case 'DWord':
                                case 'DInt':
                                case 'Real':
                                    newData.ValueLength = 2;
                                    break;
                                case 'DReal':
                                    newData.ValueLength = 4;
                                    break;
                                default:
                                    newData.ValueLength = null;
                                    break;
                            }
                        }
                        // Manage Bit column options
                        if (value == 'Bool' || value == 'Bit') {
                            self.varGridView.columnOption('Bit', 'allowEditing', true);
                            if (newData.ValueIndex == null || newData.ValueIndex == '') {
                                newData.ValueIndex = 0;
                            }
                        } else {
                            self.varGridView.columnOption('Bit', 'allowEditing', false);
                            newData.ValueIndex = 0;
                        }
                        // Manage BooleanDirection column options
                        if (value == 'String' || value == 'Real' || value == 'DReal' || value == 'DWord' || value == 'DInt') {
                            self.varGridView.columnOption('BooleanDirection', 'allowEditing', true);
                        } else {
                            self.varGridView.columnOption('BooleanDirection', 'allowEditing', false);
                            newData.BooleanDirection = false;
                        }
                    },
                },
                { key: 'Address', dataField: 'Address', dataType: 'string', caption: this.$t('Address'), required: true, width: 120 },
                { key: 'Bit', dataField: 'ValueIndex', dataType: 'number', caption: this.$t('Bit'), required: true, width: 60 },
                { key: 'BooleanDirection', dataField: 'BooleanDirection', dataType: 'boolean', caption: this.$t('Reverse'), required: false, width: 120, alignment: 'center' },
                {
                    key: 'ValueLength', dataField: 'ValueLength', dataType: 'number', caption: this.$t('Size'), required: true, width: 100,
                    editorOptions: {
                        min: 1,
                        max: 9999,
                    },
                }
            ],
            groups: this.equipment?.Groups ?? [{ id: uuid.v4(), Name: `${this.$t('Group')} 1`, Active: true, Items: [] }],
            groupConfiguration: { rows: [] },
        };
    },
    watch: {
        protocolMode(mode) {
            this.maxAddressGap = defaultMaxAddressGap(mode);
        },
    },
    mounted() {
        this.loadSerialPorts();
    },
    methods: {
        reconnectPayload() {
            return this.$refs.reconnectConfiguration
                ? this.$refs.reconnectConfiguration.payload()
                : this.equipment?.Reconnect ?? null;
        },
        onMaxAddressGapChange(value) {
            if (value == null || value == '') {
                this.maxAddressGap = defaultMaxAddressGap(this.protocolMode);
            } else if (value > 2000) {
                this.maxAddressGap = 2000;
            } else if (value < 0) {
                this.maxAddressGap = 0;
            }
        },
        async loadSerialPorts() {
            try {
                const data = await prodComEquipmentService.modbusGetSerialPorts();
                if (data?.success !== 'y' || !Array.isArray(data.ret)) {
                    return;
                }

                const ports = data.ret.map((portName) => ({ value: portName, text: portName }));
                this.availablePorts = ports;

                const currentPort = this.comPort || this.equipment?.ComPort;
                if (currentPort && data.ret.includes(currentPort)) {
                    this.comPort = currentPort;
                } else if (ports.length > 0) {
                    this.comPort = ports[0].value;
                } else {
                    this.comPort = '';
                }
            } catch (error) {
                console.error(error);
            }
        },
        connectionParameters() {
            return {
                Name: this.equipment?.Name ?? 'Modbus',
                Description: this.equipment?.Description ?? '',
                TxRefresh: Number(this.pollingPeriod),
                ApiAddress: Number(this.apiAddress),
                ConnectionType: this.connexionType,
                Host: this.ipAddress,
                TcpPort: Number(this.port),
                Timeout: Number(this.timeout),
                ComPort: this.comPort,
                BaudRate: Number(this.comSpeed),
                ByteSize: Number(this.comDataBits),
                StopBits: Number(this.comStopBit),
                Parity: Number(this.comParity),
                TransmissionMode: this.transmission,
                FrameShift: Number(this.frameShift),
                Coils: Number(this.coils),
                DiscreteInput: Number(this.discreteInputs),
                HoldingRegisters: Number(this.holdingRegisters),
                InputRegisters: Number(this.inputRegisters),
                MaxAddressGap: Number(this.maxAddressGap),
                Retries: Number(this.retryBeforeFail),
                SerialOverTCP: this.serialViaTCP,
                Reconnect: this.reconnectPayload(),
                Groups: this.groups,
            };
        },
        async onCheckConnection() {
            if (this.loadingConnectionCheck || !this.canCheckConnection) {
                return;
            }

            this.loadingConnectionCheck = true;
            try {
                const result = await prodComEquipmentService.modbusCheckConnection(this.connectionParameters());
                if (result?.success !== 'y') {
                    this.$EventBus.$emit('show-toast', new ToastAlert(this.$t(result?.ret || 'equipment.modbus.failedToConnect', result?.retParams), 'warning'));
                    return;
                }

                if (!result.ret?.Connected) {
                    const message = result.ret?.ConnectionFailedMessage || 'equipment.modbus.failedToConnect';
                    this.$EventBus.$emit('show-toast', new ToastAlert(this.$t(message), 'warning'));
                    return;
                }

                this.$EventBus.$emit('show-toast', new ToastAlert(this.$t('equipment.modbus.connectionSuccess'), 'success', this.$t('ConnectionSuccess')));
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('show-toast', new ToastAlert(this.$t('equipment.modbus.failedToConnect'), 'warning'));
            } finally {
                this.loadingConnectionCheck = false;
            }
        },
        async testPort() {
            if (this.testingPort || !this.comPort) {
                return;
            }

            this.testingPort = true;
            try {
                const result = await prodComEquipmentService.modbusTestSerialPort({
                    ComPort: this.comPort,
                    BaudRate: Number(this.comSpeed),
                    ByteSize: Number(this.comDataBits),
                    Parity: Number(this.comParity),
                    StopBits: Number(this.comStopBit),
                });

                if (result?.success === 'y' && result.ret?.Opened) {
                    this.$EventBus.$emit(
                        'show-toast',
                        new ToastAlert(this.$t(result.ret.Message, { port: this.comPort }), 'success')
                    );
                    return;
                }

                this.$EventBus.$emit('show-toast', new ToastAlert(this.$t('equipment.modbus.testPortFailed', { port: this.comPort }), 'warning'));
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('show-toast', new ToastAlert(this.$t('equipment.modbus.testPortFailed', { port: this.comPort }), 'warning'));
            } finally {
                this.testingPort = false;
            }
        },
        validate() {
            return this.invalidState ? null : true;
        },
        async saveEquipmentCommunication() {
            await this.$refs.itemConfiguration.saveEquipmentCommunication();
        },
        async refreshVariablesCounter(searchingForItems, variableCounter) { },
        /**
         * Synchronizes the data changes from the wizard into the given equipment. This method should be called before updateing / saving / adding
         * the equipment in the parent control.
         * @public This method is public.
         */
        async synchronizeEquipment() {
            this.equipment.Groups = this.groups;
            this.equipment.ApiAddress = this.apiAddress;
            this.equipment.TxRefresh = this.pollingPeriod;
            this.equipment.Timeout = this.timeout;
            this.equipment.Host = this.ipAddress;
            this.equipment.ConnectionType = this.connexionType;
            this.equipment.TcpPort = this.port;
            this.equipment.ComPort = this.comPort;
            this.equipment.BaudRate = this.comSpeed;
            this.equipment.ByteSize = this.comDataBits;
            this.equipment.StopBits = this.comStopBit;
            this.equipment.Parity = this.comParity;
            this.equipment.TransmissionMode = this.transmission;
            this.equipment.FrameShift = this.frameShift;
            this.equipment.HoldingRegisters = this.holdingRegisters;
            this.equipment.InputRegisters = this.inputRegisters;
            this.equipment.Coils = this.coils;
            this.equipment.DiscreteInput = this.discreteInputs;
            this.equipment.Retries = this.retryBeforeFail;
            this.equipment.MaxAddressGap = this.maxAddressGap;
            this.equipment.SerialOverTCP = this.serialViaTCP;
            this.equipment.Reconnect = this.reconnectPayload();
        },
    },
};
</script>
